<template>
  <div>
    <el-dialog
      title="Szczegóły widgetu"
      :lock-scroll="false"
      :before-close="handleClose"
      width="80vw"
      :visible.sync="dialogFormVisible"
    >
      <div class="header">
        <h3 class="header__title">{{ formCopy.working_name }}</h3>
        <language-switcher class="language-switcher--inverse" />
        <div>
          <el-button @click="cancelForm()">Anuluj</el-button>
          <el-button type="primary" @click="submitForm()">Zatwierdź </el-button>
        </div>
      </div>
      <el-form :model="formCopy" label-width="100px">
        <component
          :is="widgetComponent"
          :form.sync="formCopy"
          :errors="errors"
        />
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import BaseWidget from '@/components/widgets/BaseWidget'
import { Widget } from '@/api'
import { cloneDeep, isEqual } from 'lodash'
import LanguageSwitcher from '@/components/LanguageSwitcher'

export default {
  props: ['widget', 'bus'],
  data() {
    return {
      formCopy: {},
      originalForm: {},
      widgetComponent: null,
      errors: {},
      dialogFormVisible: false
    }
  },
  mounted() {
    this.bus.$on('openWidgetFormDialog', this.openDialog)
  },
  watch: {
    dialogFormVisible(value) {
      if (!value) {
        this.widgetComponent = null
      }
    }
  },
  methods: {
    openDialog(widget, errors) {
      this.formCopy = cloneDeep(widget)
      this.originalForm = widget // keep reference
      this.widgetComponent = this.getWidgetComponent(widget.resourcetype)
      this.dialogFormVisible = true
      this.errors = errors || {}
    },
    handleClose(done) {
      const formWasChanged = !isEqual(this.formCopy, this.originalForm)
      if (formWasChanged) {
        this.$confirm('Zmiany zostaną utracone.')
          .then(response => {
            done()
          })
          .catch(_ => {})
      } else {
        done()
      }
    },
    cancelForm() {
      this.dialogFormVisible = false
      this.$emit('cancel')
    },
    submitForm() {
      Widget.validate(this.formCopy)
        .then(response => {
          this.$emit('submit', this.formCopy, this.originalForm)
          this.dialogFormVisible = false
        })
        .catch(this.errorHandler)
    }
  },
  components: {
    LanguageSwitcher,
    BaseWidget
  }
}
</script>
<style lang="scss" scoped>
.link {
  font-size: 18px;
  color: #333333;
}
.header {
  position: sticky;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.7rem 2rem;
  margin-bottom: 1rem;
  border-radius: 5px;
  background: #2f4050;
  z-index: 3;

  .language-switcher {
    flex: 0 0 45%;
  }

  &__title {
    margin: 0;
    line-height: 1.5;
    flex: 0 0 35%;
    color: white;
  }
}
</style>
